import {
  queryOrderGoodsList,
  updateOrderGoods
} from "@/api/order/refund";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async queryOrderGoodsList(context, params) {
      const { data } = await queryOrderGoodsList(params);
      return data;
    },

    async updateOrderGoods(context, params) {
      const res = await updateOrderGoods(params);
      return res;
    }
  }
};
